import { render } from "./j-carousel.vue?vue&type=template&id=e68d2ab0&scoped=true"
import script from "./j-carousel.vue?vue&type=script&lang=js"
export * from "./j-carousel.vue?vue&type=script&lang=js"

import "./j-carousel.vue?vue&type=style&index=0&id=e68d2ab0&scoped=true&lang=less"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e68d2ab0"]])

export default __exports__